import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import api, { fileUrl } from "../lib/api";
import { Download } from "lucide-react";

export default function PublicShare() {
  const { token } = useParams();
  const [proj, setProj] = useState(null);
  const [err, setErr] = useState("");
  useEffect(()=>{ api.get(`/projects/share/${token}`).then(r=>setProj(r.data)).catch(()=>setErr("Not found or not ready")); },[token]);

  return (
    <div className="min-h-screen">
      <Header/>
      <main id="main" tabIndex={-1} className="max-w-4xl mx-auto px-6 md:px-10 py-12">
        {err && <div className="brutal-card text-center py-16">{err}</div>}
        {!proj && !err && <div className="text-center py-20">Loading…</div>}
        {proj && (
          <>
            <div className="marquee-tag mb-2">// SHARED · PUBLIC</div>
            <h1 className="font-display font-black type-title-lg tracking-tighter mb-4" data-testid="share-title">{proj.title}</h1>
            {proj.description && <p className="type-lead text-ink-muted mb-8">{proj.description}</p>}
            {proj.video_path && (
              <div className="brutal-card p-0 mb-6" data-testid="share-video">
                <video src={fileUrl(proj.video_path)} poster={proj.thumbnail_path ? fileUrl(proj.thumbnail_path) : undefined} controls className="w-full"/>
              </div>
            )}
            {proj.manual_md && (
              <div className="brutal-card mb-6" data-testid="share-manual">
                {proj.manual_pdf_path && (
                  <a href={fileUrl(proj.manual_pdf_path)} download className="brutal-btn mb-4 inline-flex"><Download size={14}/> Download PDF</a>
                )}
                <pre className="text-sm" style={{whiteSpace:"pre-wrap", fontFamily:"'IBM Plex Mono', monospace", lineHeight:"1.7"}}>{proj.manual_md}</pre>
              </div>
            )}
          </>
        )}
        {proj && !proj.hide_branding && (
          <div className="mt-10 text-center" data-testid="powered-badge">
            <a href="https://democraft.app" target="_blank" rel="noreferrer" className="brutal-chip inline-block hover:bg-surface-inverse hover:text-ink-inverse transition-colors">
              ⚡ POWERED BY DEMOCRAFT · From CloudCraft Labs
            </a>
          </div>
        )}
      </main>
    </div>
  );
}
